import { RECOMMENDATION_PAIRS } from './recommendationData';

export const EVAL_DATA = [
    {id: 1, name: "영역별인지기능", req: true, problems: ["기억력 장애", "지남력 장애", "언어 장애", "치매중증도(CDR 1점이상 또는 GDS 5점 이상)", "기타 인지 장애"]},
    {id: 2, name: "정신행동증상", req: true, problems: ["망상", "환각", "초조/공격성", "우울", "불안", "들뜬 기분", "무감동/무관심", "탈억제", "과민/불안정", "이상행동", "수면", "식욕/식습관"]},
    {id: 3, name: "도구적일상생활동작", req: true, problems: ["시장보기, 쇼핑", "교통수단 이용", "돈 관리", "기구 사용과 집안 일하기", "음식준비", "전화사용", "약 복용", "최근 기억", "취미 생활", "텔레비전 시청", "집안 수리"]},
    {id: 4, name: "신체건강", req: false, problems: ["이환 질병", "피부 병변", "통증의 빈도와 강도"]},
    {id: 5, name: "활동도", req: false, problems: ["사회활동", "운동", "낙상력"]},
    {id: 6, name: "영양상태", req: false, problems: ["영양불량"]},
    {id: 7, name: "투약현황", req: false, problems: ["투약 여부", "투약지시 불이행"]},
    {id: 8, name: "처치현황", req: false, problems: ["처치 여부", "처치도움 필요성"]},
    {id: 9, name: "의료기관이용현황", req: false, problems: ["단골 의사/기관", "병원 입원", "응급실 방문", "외래 방문", "일반의약품 구입"]},
    {id: 10, name: "돌봄서비스이용현황", req: false, problems: ["요양원 입소", "주야간보호", "단기보호", "가정 방문간호", "가사 지원", "음식 배달", "목욕 서비스", "복지용구/조호물품", "기타"]},
    {id: 11, name: "생활환경위기도", req: false, problems: ["생활환경", "안전상의 문제", "신체활동상의 어려움", "내외부 환경으로 인한 갈등"]},
    {id: 12, name: "안전위기도", req: true, problems: ["가족구성원의 위협", "본인의 위협", "비동거인의 위협", "응급상황"]},
    {id: 13, name: "경제위기도", req: false, problems: ["경제적 위기", "금전관리 어려움", "빚 관련 문제"]},
    {id: 14, name: "주조호자조호부담", req: false, problems: ["조호부담"]}
];

export const CLASSIFIED_CODES = [
    { group: "가. 건강 - 1. 인지기능 (A:내부)", codes: ["가-1-A1. 쉼터프로그램", "가-1-A2. 방문형인지키트", "가-1-A3. 보호자상담교육", "가-1-A4. 협약병원연결", "가-1-A5. 돌봄로봇지원", "가-1-A6. 기타(수기작성)"] },
    { group: "가. 건강 - 1. 인지기능 (B:외부)", codes: ["가-1-B1. 지역사회기관 프로그램", "가-1-B2. 장기요양서비스", "가-1-B3. 병의원 서비스", "가-1-B4. 복지용구", "가-1-B5. 치매안심병동", "가-1-B6. 치매관리주치의", "가-1-B7. 의료요양 통합돌봄사업", "가-1-B8. 노인맞춤돌봄서비스", "가-1-B9. 읍면동 통합사례관리", "가-1-B10. 재택의료센터", "가-1-B11. 일차의료 방문진료 수가 시범사업", "가-1-B12. 통합재가서비스", "가-1-B13. 기타(수기작성)"] },
    { group: "가. 건강 - 2. 투약현황 (A:내부)", codes: ["가-2-A1. 치매치료관리비", "가-2-A2. 맞춤형사례관리", "가-2-A3. 봉사자연결", "가-2-A4. 협약병원연결", "가-2-A5. 로봇지원", "가-2-A6. 약물관리지원서비스", "가-2-A7. 기타(수기작성)"] },
    { group: "가. 건강 - 2. 투약현황 (B:외부)", codes: ["가-2-B1. 지역사회기관(복지관 등) 서비스", "가-2-B2. 방문건강관리 서비스", "가-2-B3. 병의원 서비스", "가-2-B4. 동행지원 서비스", "가-2-B5. 자원봉사기관 연결", "가-2-B6. 치매관리주치의", "가-2-B7. 의료요양 통합돌봄사업", "가-2-B8. 노인맞춤돌봄서비스", "가-2-B9. 읍면동 통합사례관리", "가-2-B10. 재택의료센터", "가-2-B11. 일차의료 방문진료 수가 시범사업", "가-2-B12. 일차의료 만성질환 관리사업", "가-2-B13. 다제약물 관리사업", "가-2-B14. 기타(수기작성)"] },
    { group: "가. 건강 - 3. 신체건강 (A:내부)", codes: ["가-3-A1. 쉼터프로그램", "가-3-A2. 보호자교육", "가-3-A3. 협약병원연결", "가-3-A4. 영양보조식 지원", "가-3-A5. 신체활동 교육", "가-3-A6. 생활습관 교육", "가-3-A7. 기타(수기작성)"] },
    { group: "가. 건강 - 3. 신체건강 (B:외부)", codes: ["가-3-B1. 지역사회 건강프로그램 서비스", "가-3-B2. 보호자교육", "가-3-B3. 병의원 서비스", "가-3-B4. 장기요양서비스", "가-3-B5. 치매안심병동", "가-3-B6. 치매관리주치의", "가-3-B7. 의료요양 통합돌봄사업", "가-3-B8. 읍면동 통합사례관리", "가-3-B9. 재택의료센터", "가-3-B10. 일차의료 방문진료 수가 시범사업", "가-3-B11. 일차의료 만성질환 관리사업", "가-3-B12. 통합재가서비스", "가-3-B13. 기타(수기작성)"] },
    { group: "가. 건강 - 4. 정신행동 (A:내부)", codes: ["가-4-A1. 가족지원프로그램", "가-4-A2. 보호자교육", "가-4-A3. 맞춤형사례관리", "가-4-A4. 배회인식표", "가-4-A5. 배회감지기", "가-4-A6. 협약병원연결", "가-4-A7. 치매상담전화센터", "가-4-A8. 기타(수기작성)"] },
    { group: "가. 건강 - 4. 정신행동 (B:외부)", codes: ["가-4-B1. 지역사회기관 서비스", "가-4-B2. 병의원 서비스", "가-4-B3. 치매안심병원 서비스", "가-4-B4. 외부기관 가족프로그램", "가-4-B5. 장기요양서비스", "가-4-B6. 치매안심병동", "가-4-B7. 치매관리주치의", "가-4-B8. 읍면동 통합사례관리", "가-4-B9. 재택의료센터", "가-4-B10. 경찰서(지문등록)", "가-4-B11. 일차의료 방문진료 수가 시범사업", "가-4-B12. 통합재가서비스", "가-4-B13. 기타(수기작성)"] },
    { group: "나. 일상생활 - 1. 생활지원 (A:내부)", codes: ["나-1-A1. 조호물품제공", "나-1-A2. 가족지원프로그램", "나-1-A3. 봉사자연결", "나-1-A4. 생활용품지원", "나-1-A5. 교통이동지원", "나-1-A6. 기타(수기작성)"] },
    { group: "나. 일상생활 - 1. 생활지원 (B:외부)", codes: ["나-1-B1. 노인맞춤돌봄서비스", "나-1-B2. 재가노인지원서비스", "나-1-B3. 가사간병서비스", "나-1-B4. 가사지원서비스", "나-1-B5. 식사배달서비스", "나-1-B6. 세탁서비스", "나-1-B7. 목욕서비스", "나-1-B8. 교통이동지원서비스", "나-1-B9. 의료요양 통합돌봄사업", "나-1-B10. 기타(수기작성)"] },
    { group: "나. 일상생활 - 2. 경제위기 (A:내부)", codes: ["나-2-A1. 공공후견인제도", "나-2-A2. 맞춤형사례관리", "나-2-A3. 생활용품지원", "나-2-A4. 치매치료관리비", "나-2-A5. 기타(수기작성)"] },
    { group: "나. 일상생활 - 2. 경제위기 (B:외부)", codes: ["나-2-B1. 관공서 재정지원 서비스", "나-2-B2. 지역사회기관 재정지원 서비스", "나-2-B3. 일자리 연계", "나-2-B4. 생활물품 지원 연계 서비스", "나-2-B5. 주거지원서비스", "나-2-B6. 기타(수기작성)"] },
    { group: "나. 일상생활 - 3. 사회생활지원 (A:내부)", codes: ["나-3-A1. 말벗서비스", "나-3-A2. 취미/여가활동연계", "나-3-A3. 치매관련도서연계", "나-3-A4. 기타(수기작성)"] },
    { group: "나. 일상생활 - 3. 사회생활지원 (B:외부)", codes: ["나-3-B1. 말벗서비스", "나-3-B2. 취미/여가활동연계", "나-3-B3. 지역도서관 연계", "나-3-B4. 장기요양서비스", "나-3-B5. 통합재가서비스", "나-3-B6. 기타(수기작성)"] },
    { group: "나. 일상생활 - 4. 법률지원 (A:내부)", codes: ["나-4-A1. 공공후견인제도", "나-4-A2. 기타(수기작성)"] },
    { group: "나. 일상생활 - 4. 법률지원 (B:외부)", codes: ["나-4-B1. 성년후견인", "나-4-B2. 기타 법률지원", "나-4-B3. 기타(수기작성)"] },
    { group: "다. 안전 - 1. 안전관리 (A:내부)", codes: ["다-1-A1. 낙상교육 제공", "다-1-A2. 배회인식표", "다-1-A3. 배회감지기", "다-1-A4. 공공후견인제도", "다-1-A5. 안전관리물품제공", "다-1-A6. 안전관리교육제공", "다-1-A7. 기타(수기작성)"] },
    { group: "다. 안전 - 1. 안전관리 (B:외부)", codes: ["다-1-B1. 경찰서(지문등록, 학대 등)", "다-1-B2. 노인맞춤돌봄서비스", "다-1-B3. 노인보호전문기관 서비스", "다-1-B4. 고독사예방 서비스", "다-1-B5. 지역사회기관 응급안전서비스", "다-1-B6. 낙상예방 보조기구 서비스", "다-1-B7. 가스안전차단기 서비스", "다-1-B8. 기타(수기작성)"] },
    { group: "다. 안전 - 2. 주거환경관리 (A:내부)", codes: ["다-2-A1. 맞춤형사례관리", "다-2-A2. 기타(수기작성)"] },
    { group: "다. 안전 - 2. 주거환경관리 (B:외부)", codes: ["다-2-B1. 청소 및 방역서비스 서비스", "다-2-B2. 집안 정리정돈 서비스", "다-2-B3. 토탈협업케어서비스", "다-2-B4. 기타(수기작성)"] },
    { group: "라. 가족 - 1. 조호자 돌봄부담 (A:내부)", codes: ["라-1-A1. 가족지원프로그램", "라-1-A2. 가족상담지원", "라-1-A3. 돌봄부담분석", "라-1-A4. 맞춤형사례관리", "라-1-A5. 치매상담전화센터", "라-1-A6. 기타(수기작성)"] },
    { group: "라. 가족 - 1. 조호자 돌봄부담 (B:외부)", codes: ["라-1-B1. 외부기관 자조모임 서비스", "라-1-B2. 소득지원 및 일자리 서비스", "라-1-B3. 치매가족휴가제", "라-1-B4. 문화·여가·취미 활동 지원 서비스", "라-1-B5. 장기요양서비스", "라-1-B6. 정신건강복지센터", "라-1-B7. 통합재가서비스", "라-1-B8. 기타(수기작성)"] }
];

export const ALL_SERVICES = CLASSIFIED_CODES.flatMap((group) =>
  group.codes.map((code) => ({ group: group.group, code }))
);

export const STATUS_OPTIONS = [
  { value: "issue", label: "문제 있음" },
  { value: "none", label: "문제 없음" },
  { value: "unable", label: "평가 불가" },
];

export const UNABLE_REASONS = [
  "대상자 응답 곤란",
  "보호자 정보 부족",
  "관련 자료 부족",
  "평가시간 부족",
  "기타",
];

export const NO_INTERVENTION_REASONS = [
  "대상자 거부",
  "보호자 거부",
  "기존 서비스 이용 중",
  "대상 기준 미충족",
  "연계 가능한 자원 없음",
  "추후 재평가 예정",
  "기타",
];

const PREFIX_BY_EVAL = {
  1: ["가-1"], 2: ["가-4"], 3: ["나-1", "나-3", "가-2"], 4: ["가-3"],
  5: ["가-3", "나-3"], 6: ["가-3"], 7: ["가-2"], 8: ["가-3"],
  9: ["가-3", "가-2"], 10: ["나-1", "가-1"], 11: ["다-2", "다-1"],
  12: ["다-1"], 13: ["나-2", "나-4"], 14: ["라-1"],
};

export function getRecommendedServices(evalId, problemName) {
  const id = Number(evalId);
  if (id === 1) {
    if (problemName.includes('치매중증도')) return ['가-1-B2. 장기요양서비스', '가-1-B5. 치매안심병동', '가-1-B12. 통합재가서비스', '가-1-A6. 기타(수기작성)', '가-1-B13. 기타(수기작성)'];
    return ['가-1-A1. 쉼터프로그램', '가-1-A2. 방문형인지키트', '가-1-B1. 지역사회기관 프로그램', '가-1-A5. 돌봄로봇지원', '가-1-A6. 기타(수기작성)', '가-1-B13. 기타(수기작성)'];
  }
  if (id === 2) {
    if (['망상', '환각', '초조/공격성', '이상행동', '들뜬 기분', '탈억제'].includes(problemName)) return ['가-4-A6. 협약병원연결', '가-4-B3. 치매안심병원 서비스', '가-4-B2. 병의원 서비스', '가-4-B6. 치매안심병동', '가-4-A8. 기타(수기작성)', '가-4-B13. 기타(수기작성)'];
    if (['우울', '불안', '무감동/무관심', '과민/불안정'].includes(problemName)) return ['가-4-A7. 치매상담전화센터', '가-4-B1. 지역사회기관 서비스', '가-4-A1. 가족지원프로그램', '가-4-A8. 기타(수기작성)', '가-4-B13. 기타(수기작성)'];
    if (['수면', '식욕/식습관'].includes(problemName)) return ['가-3-B3. 병의원 서비스', '가-3-B6. 치매관리주치의', '가-3-B11. 일차의료 만성질환 관리사업', '가-3-A7. 기타(수기작성)', '가-3-B13. 기타(수기작성)'];
  }
  if (id === 3) {
    if (['시장보기, 쇼핑', '음식준비', '기구 사용과 집안 일하기'].includes(problemName)) return ['나-1-B5. 식사배달서비스', '나-1-B1. 노인맞춤돌봄서비스', '나-1-B2. 재가노인지원서비스', '나-1-B4. 가사지원서비스', '나-1-A6. 기타(수기작성)', '나-1-B10. 기타(수기작성)'];
    if (['돈 관리', '집안 수리'].includes(problemName)) return ['나-2-A1. 공공후견인제도', '나-2-B1. 관공서 재정지원 서비스', '다-2-B3. 토탈협업케어서비스', '나-2-A5. 기타(수기작성)', '나-2-B6. 기타(수기작성)'];
    if (problemName === '약 복용') return ['가-2-A6. 약물관리지원서비스', '가-2-B13. 다제약물 관리사업', '가-2-A2. 맞춤형사례관리', '가-2-A7. 기타(수기작성)', '가-2-B14. 기타(수기작성)'];
    if (problemName === '교통수단 이용') return ['나-1-A5. 교통이동지원', '나-1-B8. 교통이동지원서비스', '나-1-A6. 기타(수기작성)', '나-1-B10. 기타(수기작성)'];
    return ['가-1-A1. 쉼터프로그램', '나-3-B2. 취미/여가활동연계', '나-3-B1. 말벗서비스', '나-3-A4. 기타(수기작성)', '나-3-B6. 기타(수기작성)'];
  }
  if (id === 12) {
    if (['가족구성원의 위협', '본인의 위협', '비동거인의 위협'].includes(problemName)) return ['다-1-B3. 노인보호전문기관 서비스', '다-1-B1. 경찰서(지문등록, 학대 등)', '라-1-A2. 가족상담지원', '다-1-A7. 기타(수기작성)', '다-1-B8. 기타(수기작성)'];
    if (problemName === '응급상황') return ['다-1-B5. 지역사회기관 응급안전서비스', '다-1-A5. 안전관리물품제공', '다-1-A7. 기타(수기작성)', '다-1-B8. 기타(수기작성)'];
  }
  const prefixes = PREFIX_BY_EVAL[id] || [];
  const candidates = ALL_SERVICES.filter((item) => prefixes.some((prefix) => item.code.startsWith(prefix)));
  return candidates.slice(0, 6).map((item) => item.code);
}
const GOALS = {
  "가-1": ["현재의 인지기능 수준을 유지한다.", "잔존 인지기능을 활용하여 인지 저하 속도를 완화한다."],
  "가-2": ["처방에 따라 약물을 규칙적으로 복용한다.", "지속적인 투약 관리를 통해 건강상태를 안정적으로 유지한다."],
  "가-3": ["전반적인 신체 건강상태를 유지한다.", "건강한 생활습관을 유지하여 신체기능 저하를 최소화한다."],
  "가-4": ["정신행동증상을 완화하여 정서적 안정을 유지한다.", "문제행동 발생 시 적절히 대처하여 안전을 유지한다."],
  "나-1": ["일상생활 수행능력을 유지하고 안정적인 생활을 지속한다."],
  "나-2": ["경제적 위기 상황을 완화하고 필요한 지원을 활용한다."],
  "나-3": ["사회적 관계와 지역사회 활동 참여를 유지한다."],
  "나-4": ["법적 권리와 자기결정권을 보호한다."],
  "다-1": ["일상생활 중 안전사고 위험을 줄이고 안전을 유지한다."],
  "다-2": ["안전하고 위생적인 주거환경을 유지한다."],
  "라-1": ["조호자의 신체적·정서적 부담을 완화하고 지속 가능한 돌봄환경을 유지한다."],
};

const RECOMMENDATION_TERMS = [
  '쉼터', '인지', '기억력', '지남력', '보호자', '상담', '교육', '협약병원', '병의원', '진료',
  '돌봄로봇', '장기요양', '복지용구', '치매안심병동', '치매관리주치의', '통합돌봄', '노인맞춤돌봄',
  '사례관리', '약물', '투약', '치료관리비', '영양', '신체활동', '생활습관', '가족', '배회',
  '주야간보호', '식사배달', '말벗', '취미', '도서', '후견', '법률', '낙상', '경찰', '학대',
  '고독사', '응급안전', '가스', '청소', '방역', '정리정돈', '자조모임', '가족휴가', '정신건강',
  '생활용품', '조호물품', '교통', '이동', '가사', '목욕', '세탁', '재택의료', '방문건강', '주거',
];

const RECOMMENDATION_ALIASES = {
  '방문형인지키트': ['인지키트', '인지활동', '인지학습'],
  '보호자상담교육': ['보호자', '상담', '교육'],
  '가족지원프로그램': ['가족', '보호자', '돌봄'],
  '지역사회기관 프로그램': ['지역사회', '프로그램', '사회활동'],
  '약물관리지원서비스': ['약물', '투약', '복약'],
  '신체활동 교육': ['신체활동', '운동', '체조'],
  '안전관리교육제공': ['안전', '사고예방', '교육'],
  '안전관리물품제공': ['안전', '안전용품', '사고예방'],
  '지역사회기관 응급안전서비스': ['응급', '안전', '응급상황'],
  '가족상담지원': ['가족', '보호자', '상담', '조호'],
};

function normalizeRecommendationText(value) {
  return String(value || '').replace(/\s+/g, '').replace(/[·,()./-]/g, '').toLowerCase();
}

function uniqueText(values) {
  return [...new Set(values.filter(Boolean))];
}

function getRecommendationKeywords(serviceName, problemName) {
  const compactService = normalizeRecommendationText(serviceName);
  const serviceKeywords = RECOMMENDATION_TERMS.filter((term) => compactService.includes(normalizeRecommendationText(term)));
  const aliases = RECOMMENDATION_ALIASES[serviceName] || [];
  const problemKeywords = String(problemName || '')
    .split(/[\s,/()]+/)
    .map((token) => token.trim())
    .filter((token) => token.length >= 2 && !['장애', '여부', '필요성', '현황', '기타'].includes(token));
  return {
    serviceKeywords: uniqueText([...serviceKeywords, ...aliases]),
    problemKeywords: uniqueText(problemKeywords),
  };
}

export function getRecommendationSet(serviceCode, problemName = '') {
  const prefix = serviceCode.split('-').slice(0, 2).join('-');
  const serviceName = serviceCode.split('. ')[1] || serviceCode;
  const fallbackGoals = GOALS[prefix] || ['개별 욕구에 맞는 지원을 통해 생활 안정성을 높인다.'];
  const isInternal = serviceCode.includes('-A');
  const fallbackDetails = isInternal
    ? [`${serviceName}를 제공하고 대상자의 이용 여부를 확인한다.`, `${serviceName} 이용을 지원하고 필요 시 사후 점검한다.`]
    : [`${serviceName} 이용을 연계하고 서비스 이용 여부를 확인한다.`, `${serviceName} 신청을 지원하고 연계 결과를 점검한다.`];
  const { serviceKeywords, problemKeywords } = getRecommendationKeywords(serviceName, problemName);
  const compactService = normalizeRecommendationText(serviceName);

  const pairs = RECOMMENDATION_PAIRS
    .map((pair, index) => {
      const haystack = normalizeRecommendationText(`${pair.goal} ${pair.detail}`);
      let score = 0;
      if (compactService.length >= 3 && haystack.includes(compactService)) score += 30;
      serviceKeywords.forEach((keyword) => {
        if (haystack.includes(normalizeRecommendationText(keyword))) score += 8;
      });
      problemKeywords.forEach((keyword) => {
        if (haystack.includes(normalizeRecommendationText(keyword))) score += 3;
      });
      return { ...pair, score, index };
    })
    .filter((pair) => pair.score > 0)
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .slice(0, 16)
    .map(({ goal, detail }) => ({ goal, detail }));

  const goals = uniqueText([...pairs.map((pair) => pair.goal), ...fallbackGoals]).slice(0, 8);
  const details = uniqueText([...pairs.map((pair) => pair.detail), ...fallbackDetails]).slice(0, 12);
  return { goals, details, pairs };
}
export function createId(prefix = "id") {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}
